// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"FiltersModal_paginationPageDropdownWrap__CQCiy","modal":"FiltersModal_modal__PXoOJ","showResultsButton":"FiltersModal_showResultsButton__o597y"};